import React, { useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Grid, Paper, Tabs, Card, AppBar, Tab
} from '@material-ui/core'

import { getOrgUnitInfo, deleteUnit } from '../../../../redux/actions'

import OrgUnitMgmtUnitList from './OrgUnitMgmtUnitList'
import OrgUnitMgmtCreateUnit from './OrgUnitMgmtCreateUnit'
import OrgUnitMgmtEditUnit from './OrgUnitMgmtEditUnit'
import OrgUnitMgmtMonitoring from './OrgUnitMgmtMonitoring'
import OrgUnitMgmtAdvanced from './OrgUnitMgmtAdvanced'

import TreeView from '@material-ui/lab/TreeView'
import { UnitTree, TabPanel, ConfirmToast, NotificationToast } from '../../tools'

import { makeStyles, withStyles, darken } from '@material-ui/core/styles'

import { keyify2 } from '../../../../utils'

// import Tree from './Tree'
// import TreeView from '@material-ui/lab/TreeView'
// import TreeItem from '@material-ui/lab/TreeItem'
// import { Select } from '@material-ui/core'

// react treeview -- https://codesandbox.io/s/jzl910o413

const useStyles = makeStyles((theme) => ({
  unitTree: {
    width: 'fit-content',
    marginLeft: '-0.5em',
    minWidth: '12.5em'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.default,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    color: '#000'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 350,
    maxWidth: 350
  },
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#A4D164'
    }
  },
  cssLabel: {
    '&$cssFocused': {
      color: '#A4D164'
    }
  },
  cssFocused: {},
  singleChip: {
    width: '85%'
  },
  editUserPaper: {
    backgroundColor: theme.palette.action.selected,
    padding: theme.spacing(2)
  },
  tabBar: {
    backgroundColor: '#A4D164'
  },
  tabHeaders: {
    fontWeight: 'bold'
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  deleteBtn: {
    color: '#fff',
    backgroundColor: '#e57373',
    '&:hover': {
      backgroundColor: '#d05b5b'
    }
  },
  editBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  saveBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  contentGridShow: {
  },
  contentGridHide: {
    maxHeight: '0px',
    transition: '0.5s',
    overflow: 'hidden'
  },
  day: {
    width: 'auto',
    height: '2.75em',
    fontSize: '1em',
    // marginLeft: '0.25em',
    // marginRight: '0.25em',
    color: 'inherit',
    maxHeight: '90%',
    '&:hover': {
      backgroundColor: 'rgba(59, 134, 247, 0.4)'
    }
  },
  nonCurrentMonthDay: {
    color: theme.palette.text.disabled
  },
  activeDate: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  exclusionPicker: {
    width: '100%'
  },
  dateModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50%',
    marginLeft: 'auto',
    marginRight: 'auto',
    zIndex: '1050 !important'
  },
  modalContainer: {
    padding: theme.spacing(2, 4, 3),
    height: '85%'
  },
  modalPaper: {
    border: '1px solid #000',
    boxShadow: theme.shadows[5],
    width: '100%',
    height: '30em'
  },
  dateList: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    maxHeight: '14.5em',
    overflow: 'scroll'
  },
  disabledAvatar: {
    backgroundColor: theme.palette.divider
  },
  enabledAvatar: {
    backgroundColor: '#3984f7'
  },
  dateAppBar: {
    height: '15%'
  },
  pickDateChip: {
    backgroundColor: '#A4D164',
    color: '#fff'
  },
  addExclusionBtn: {
    backgroundColor: '#A4D164',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#719E31'
    }
  },
  containerCard: {
    backgroundColor: '#f5f5f5'
  },
  modalAppBar: {
    height: '15%',
    backgroundColor: '#007BFF'
  },
  changeButton: {
    marginBottom: '5px',
    marginTop: '0px',
    color: '#A4D164',
    fontWeight: 'bold'
  },
  saveButton: {
    backgroundColor: '#007bff',
    color: '#f5f5f5'
  },
  helperTextLine: {
    color: '#FF0404'
  },
  aupSaveButton: {
    backgroundColor: '#A4D164',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#719E31'
    }
  },
  radioButton: {
    '&$checked': {
      color: '#4B8DF8'
    }
  },
  supervisorContainer: {
    maxHeight: '18em',
    width: '100%',
    padding: theme.spacing(2, 0),
    marginLeft: 'auto',
    marginRight: 'auto',
    overflowY: 'scroll'
  },
  greyColor: {
    color: '#0000008A'
  },
  checked: {},
  deleteUnitBtn: {
    backgroundColor: 'red',
    color: '#FFFFFF'
  },
  datePickerLabel: {
    '& .MuiFormLabel-root': {
      textTransform: 'capitalize',
      fontSize: '1.25em',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: 600,
      lineHeight: 1.75,
      letterSpacing: '0.0285em',
      '&.Mui-focused': {
        color: darken('#3984f7', 0.25)
      }
    },
    '&.MuiInputLabel-shrink': {
      transform: 'translate(12px, 6px) scale(0.6)'
    },
    '& .MuiInput-underline': {
      '&:after': {
        borderColor: darken('#3984f7', 0)
      }
    }
  },
  categoryButtonLabel: {
    lineHeight: 'normal',
    height: '2.5em'
  },
  categoryDisableBtn: {
    textTransform: 'none',
    backgroundColor: '#A4D164',
    color: '#FFFFFF',
    width: '7em',
    '&:hover': {
      backgroundColor: '#80a54b'
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabledBackground
    }
  },
  categoryEnableBtn: {
    textTransform: 'none',
    marginBottom: '.5em',
    backgroundColor: '#007BFF',
    color: '#FFFFFF',
    width: '7em',
    '&:hover': {
      backgroundColor: '#0f6acc'
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabledBackground
    }
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&$focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  focused: {}
}))

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: 'transparent',
    '& > span': {
      maxWidth: 60,
      width: '100%',
      backgroundColor: '#3984f7'
    }
  }
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />)

/**
 * Returns organizational unit management forms
 */
const OrgUnitMgmt = () => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const textClasses = useTextStyles()

  const TreeData = useSelector(state => state.auth.unitTree)
  const orgUnitInfo = useSelector(state => state.orgUnits.selectedUnit)
  const Permissions = useSelector(state => state.auth.permissions)

  // const [editingSupervisor, setEditingSupervisor] = useState(false)

  // unit schedule info
  // const [newInfo, setNewInfo] = useState()
  const [unitMonInfo, setUnitMonInfo] = useState()

  const [unitInfo, setUnitInfo] = useState({
    activeWorkstations: '',
    address: '',
    address2: '',
    captureCount: '',
    city: '',
    isBaseUnit: '',
    maxUserCount: '',
    postalCode: '',
    state: '',
    unitDesc: '',
    unitName: '',
    unitSupervisors: [],
    key: '',
    enabled: 0
  })

  // const [targetSupervisor, setTargetSupervisor] = useState({
  //   firstName: '',
  //   lastName: '',
  //   title: '',
  //   email: '',
  //   cell: '',
  //   roleID: '',
  //   supervisorID: '',
  //   units: []
  // })

  const [unitName, setUnitName] = useState('')
  const [unitDesc, setUnitDesc] = useState('')
  const [address, setAddress] = useState('')
  const [address2, setAddress2] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [postalCode, setPostalCode] = useState('')

  const [selectedKeys, setSelectedKeys] = useState(keyify2(TreeData))
  const [selectedKey, setSelectedKey] = useState(TreeData[0].key)

  const [tabValue, setTabValue] = useState('unit')
  const [hasChild, setHasChild] = useState(false)

  // handles information being set by selected unit in the tree
  const handleNodeSelect = async (keySelected, title, isParent) => {
    if (tabValue !== 'unit') {
      const confirmation = await ConfirmToast(
        tabValue === 'new'
          ? { msg: 'Are you sure you want to change the parent unit?', txt: 'This will reset any changes made.' }
          : { msg: 'Do you want to change units?', txt: 'This action will clear any unsaved changes on the current unit.' }
      )

      if (!confirmation) { return false }
    }

    if (keySelected !== selectedKey) {
      setTabValue('unit')
      setSelectedKey(keySelected)
      dispatch(getOrgUnitInfo(keySelected))
      setHasChild(isParent)
    }
  }

  const handleNodeAugment = async (key, children, isExpanded) => {
    if (isExpanded) {
      const tempSelected = [...selectedKeys]
      const keysToRemove = [key, ...keyify2(children)]

      const newSelected = tempSelected.filter((selectedKey) => keysToRemove.findIndex((removeKey) => removeKey === selectedKey) === -1)

      setSelectedKeys(newSelected)
    } else {
      const tempSelected = [...selectedKeys]
      const keysToAdd = [key, ...keyify2(children)]
      const addedKeys = []

      keysToAdd.forEach((addKey) => {
        if (tempSelected.findIndex((selectedKey) => selectedKey === addKey) === -1) {
          addedKeys.push(addKey)
        }
      })

      setSelectedKeys([...selectedKeys, ...addedKeys])
    }
  }

  const setData = (orgUnitInfo) => {
    setUnitName(orgUnitInfo.unitName ? orgUnitInfo.unitName : '')
    setUnitDesc(orgUnitInfo.unitDesc ? orgUnitInfo.unitDesc : '')
    setAddress(orgUnitInfo.address ? orgUnitInfo.address : '')
    setAddress2(orgUnitInfo.address2 ? orgUnitInfo.address2 : '')
    setCity(orgUnitInfo.city ? orgUnitInfo.city : '')
    setState(orgUnitInfo.state ? orgUnitInfo.state : '')
    setPostalCode(orgUnitInfo.postalCode ? orgUnitInfo.postalCode : '')
  }

  useMemo(() => {
    if (Object.keys(orgUnitInfo).length === 0) {
      dispatch(getOrgUnitInfo(selectedKey))
    } else {
      if (orgUnitInfo.key !== selectedKey) {
        dispatch(getOrgUnitInfo(selectedKey))
      } else {
        // const { unitSupervisors } = orgUnitInfo
        const unitSupervisors = (() => {
          if (typeof orgUnitInfo === 'object' && Boolean(orgUnitInfo) && Array.isArray(orgUnitInfo.unitSupervisors)) { return orgUnitInfo.unitSupervisors }

          return []
        })()

        // const unitSupervisorList = []
        // if (unitSupervisors.length !== 0) {
        //   userRoleSupervisors.forEach((roleSup) => {
        //     roleSup.roleSupervisors.forEach((supervisor) => {
        //       const supervisorIndex = unitSupervisors.findIndex((unitSup) => {
        //         return supervisor.supervisorID === unitSup.supervisorID
        //       })

        //       if (supervisorIndex !== -1) {
        //         unitSupervisorList.push({
        //           ...supervisor,
        //           role: roleSup.roleName,
        //           roleID: roleSup.roleID
        //         })
        //       }
        //     })
        //   })
        // }

        const unitSupervisorList = unitSupervisors.reduce((arr, supInfo) => {
          if (typeof supInfo && Boolean(supInfo) && Boolean(supInfo.supervisorID)) { arr.push({ ...supInfo }) }
          return arr
        }, [])

        setUnitInfo({
          ...orgUnitInfo,
          unitSupervisors: unitSupervisorList
        })
        setUnitName(orgUnitInfo.unitName)
        setData(orgUnitInfo)

        const monitoringInfo = {
          ...orgUnitInfo.schedule,
          exclusions: orgUnitInfo.exclusions
        }

        setUnitMonInfo({
          ...orgUnitInfo,
          ...monitoringInfo
        })
        // setNewInfo(monitoringInfo)
      }
    }
    // setData(unitInfo)
  }, [orgUnitInfo, dispatch, selectedKey])

  // const handleBackTrack = async (form) => {
  //   setFormSwap(form)
  //   if (changesMade) {
  //     const changeStat = await ConfirmToast({ msg: 'Are you sure you want to go back?', txt: 'This will reset any changes made.' })
  //     if (changeStat === true) {
  //       // setUnitName('')
  //       setUnitDesc('')
  //       setAddress('')
  //       setAddress2('')
  //       setCity('')
  //       setState('')
  //       setPostalCode('')
  //       setFormSwap('unit')
  //     } else if (formSwap === 'monitoring' && changeStat === true) {
  //       setFormSwap('unit')
  //     }
  //   } else {
  //     if (formSwap === 'monitoring' || formSwap === 'edit' || formSwap === 'new') {
  //       setFormSwap('unit')
  //     }
  //   }
  // }

  const handleTabSwap = (tabVal, changesMade = false) => {
    if (!changesMade) {
      if (tabValue === 'edit') {
        setUnitDesc('')
        setAddress('')
        setAddress2('')
        setCity('')
        setState('')
        setPostalCode('')
      }
    }
    setTabValue(tabVal)
  }

  const saveBackTrack = async () => {
    if (tabValue === 'monitoring') {
      dispatch(getOrgUnitInfo(selectedKey))
    } else {
      // setUnitName('')
      setUnitDesc('')
      setAddress('')
      setAddress2('')
      setCity('')
      setState('')
      setPostalCode('')
      setTabValue('unit')
      dispatch(getOrgUnitInfo(selectedKey))
    }
  }

  // const handleSuccessBackTrack = () => {
  //   setEditingSupervisor(false)
  //   setTargetSupervisor({
  //     firstName: '',
  //     lastName: '',
  //     title: '',
  //     email: '',
  //     cell: '',
  //     roleID: '',
  //     supervisorID: '',
  //     units: []
  //   })
  // }

  // const handleSupervisorEdit = (e, userInfo) => {
  //   e.preventDefault()
  //   setTargetSupervisor({
  //     cell: userInfo.officePhone,
  //     email: userInfo.emailAddress,
  //     firstName: userInfo.firstName,
  //     lastName: userInfo.lastName,
  //     title: userInfo.jobTitle,
  //     roleName: userInfo.role,
  //     roleID: userInfo.roleID,
  //     supervisorID: userInfo.supervisorID,
  //     units: userInfo.units
  //   })
  //   setEditingSupervisor(true)
  // }

  const handleDeleteUnit = async (unitID) => {
    const confirmDelete = await ConfirmToast({ msg: 'Are you sure you want to delete this unit?', txt: 'This action is not reversable. All associated infomration will be lost.' })
    if (confirmDelete) {
      setSelectedKey(TreeData[0].key)
      dispatch(deleteUnit(unitID, fireDeleteSuccess, fireDeleteFailure))
    }
  }

  const fireDeleteSuccess = () => {
    NotificationToast(false, 'Unit deleted successfully!')
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Unable to delete unit.')
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  return (
    <Grid container direction='row'>
      <Grid item container direction='column' spacing={2} className='mx-auto my-auto'>
        <Grid container item direction='row'>
          <h2 className=''>OU Settings</h2>
        </Grid>

        <Grid container item direction='row' spacing={2} className='mx-auto'>
          <Grid item xs={4}>
            <Paper elevation={2} className='w-100 p-3'>
              <TreeView expanded={selectedKeys} className={classes.unitTree} disableSelection>
                <UnitTree
                  onNodeSelect={handleNodeSelect}
                  selectedKeys={[selectedKey]}
                  treeData={TreeData}
                  expandedKeys={selectedKeys}
                  onNodeAugment={handleNodeAugment}
                />
              </TreeView>
            </Paper>

          </Grid>

          <Grid item xs={8}>
            <Card className={`${classes.containerCard}`}>
              <AppBar position='static' className={classes.tabBar}>
                <StyledTabs
                  value={tabValue}
                  onChange={(e, tabVal) => handleTabSwap(tabVal)}
                  centered
                  style={{ display: tabValue === 'new' || tabValue === 'edit' ? 'none' : '' }}
                // variant='scrollable'
                // scrollButtons='auto'
                >
                  <Tab
                    label='Summary' value='unit' {...a11yProps(0)}
                    className={classes.tabHeaders}
                  />
                  <Tab
                    label='Monitoring' value='monitoring' {...a11yProps(1)}
                    className={classes.tabHeaders}
                  />
                  <Tab
                    label='Advanced' value='advanced' {...a11yProps(2)}
                    className={classes.tabHeaders}
                  />
                  <Tab value='edit' style={{ display: 'none' }} />
                  <Tab value='new' style={{ display: 'none' }} />
                </StyledTabs>
              </AppBar>

              <TabPanel index='unit' value={tabValue}>
                <OrgUnitMgmtUnitList
                  onTabSwap={(tabVal) => setTabValue(tabVal)}
                  // handleSuccessBackTrack={handleSuccessBackTrack}
                  setData={setData}
                  setUnitName={setUnitName}
                  unitInfo={unitInfo}
                  // setEditingSupervisor={setEditingSupervisor}
                  // handleSupervisorEdit={handleSupervisorEdit}
                  // targetSupervisor={targetSupervisor}
                  // editingSupervisor={editingSupervisor}
                  classes={classes}
                  StyledTabs={StyledTabs}
                  a11yProps={a11yProps}
                  hasChild={hasChild}
                  permissions={Permissions}
                  handleDeleteUnit={handleDeleteUnit}
                />
              </TabPanel>

              <TabPanel index='monitoring' value={tabValue}>
                <OrgUnitMgmtMonitoring
                  onSaveBackTrack={saveBackTrack}
                  unitName={unitName}
                  newInfo={unitMonInfo}
                  selectedKey={selectedKey}
                  // enabled={unitInfo.disableMonitoring}
                  classes={classes}
                  StyledTabs={StyledTabs}
                  a11yProps={a11yProps}
                />
              </TabPanel>

              <TabPanel index='advanced' value={tabValue}>
                <OrgUnitMgmtAdvanced
                  onSaveBackTrack={saveBackTrack}
                  unitName={unitName}
                  newInfo={unitInfo}
                  selectedKey={selectedKey}
                  classes={classes}
                  StyledTabs={StyledTabs}
                  a11yProps={a11yProps}
                />
              </TabPanel>

              <TabPanel index='new' value={tabValue}>
                <OrgUnitMgmtCreateUnit
                  onBackTrack={() => handleTabSwap('unit')}
                  onSaveBackTrack={saveBackTrack}
                  unitName={unitName}
                  selectedKey={selectedKey}
                  classes={classes}
                  textClasses={textClasses}
                />
              </TabPanel>

              <TabPanel index='edit' value={tabValue}>
                <OrgUnitMgmtEditUnit
                  onTabSwap={handleTabSwap}
                  unitName={unitName}
                  unitDesc={unitDesc}
                  address={address}
                  address2={address2}
                  city={city}
                  state={state}
                  postalCode={postalCode}
                  selectedKey={selectedKey}
                  classes={classes}
                  textClasses={textClasses}
                />
              </TabPanel>
            </Card>
          </Grid>
        </Grid>

      </Grid>
    </Grid>
  )
}

export default OrgUnitMgmt
